import theme from "client/theme";
import { ClaimInfoRequest } from "client/types";
import Text from "client/ui-components/Text";
import React from "react";

export default function AdditionalRemarks({ infoRequests }: { infoRequests: ClaimInfoRequest[] }) {
  const answeredRequests = infoRequests.filter(request => request.responded_at).reverse();

  if (answeredRequests.length === 0) {
    return null;
  }

  return (
    <div className="mb-35">
      <Text className="mb-2" fontWeight={400} color={theme.ui.colors.gray600}>
        Additional Remarks
      </Text>
      <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        {answeredRequests.map(request => (
          <div key={request.id}>
            <Text fontWeight={700} color={"#111827"} lineHeight="24px" fontSize="14px">
              {request.request_message.charAt(0).toUpperCase() + request.request_message.slice(1)}
            </Text>
            <Text color={theme.ui.colors.primary700} lineHeight="20px" fontSize="14px">
              {request.response_message
                ? request.response_message.charAt(0).toUpperCase() +
                  request.response_message.slice(1)
                : ""}
            </Text>
          </div>
        ))}
      </div>
    </div>
  );
}
